import {
  buildCollection,
  buildProperty,
  type EntityReference,
} from "@firecms/core";
import { getEventPath, type EventCollectionId } from "../utils";

export type ContentInstall = {
  uid: string;
  participantRef?: EntityReference;
  installedContentVersion: number;
  installedContentAt?: Date;
};

export const buildContentInstallsPath = (id: EventCollectionId) =>
  `${getEventPath(id)}/contentInstalls`;

export const buildContentInstallsCollection = (id: EventCollectionId) =>
  buildCollection<ContentInstall>({
    name: "Content installs",
    singularName: "Content install",
    description: "Offline package version installed by each participant.",
    path: buildContentInstallsPath(id),
    id: "content_installs",
    icon: "SystemUpdate",
    group: "Stats",
    hideFromNavigation: true,
    permissions: {
      read: true,
      edit: false,
      create: false,
      delete: false,
    },
    properties: {
      uid: buildProperty({
        name: "UID",
        dataType: "string",
      }),
      participantRef: buildProperty({
        name: "Participant",
        dataType: "reference",
        path: `${getEventPath(id)}/participant`,
      }),
      installedContentVersion: buildProperty({
        name: "Installed version",
        dataType: "number",
      }),
      installedContentAt: buildProperty({
        name: "Installed at",
        dataType: "date",
      }),
    },
  });
